import { Col, Flex, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../../contexts/AuthContext";
import query from "../../../../server/constants.api";
import logger from "../../../../server/server";
import useFetch from "../../../../server/useFetch";
import {
  PageContent,
  PageSection,
} from "../../../../styles/global/Pages.styled";
import Theme from "../../../../styles/Theme/Theme";
import { SelectAtomic } from "../../Atomics/SelectAtomic";
import Spinner from "../../Atomics/Spinner";
import { Text } from "../../Atomics/Text";

const SegmentedWarper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 1%;
`;

const SegmentedControlStyle = styled.div`
  display: flex;
  background-color: ${Theme.color["white"]};
  border-radius: 30px;
  /* box-shadow: ${Theme.shadow.level3}; */
  height: 45px; //50px
  gap: 10px; //20px
  padding: 0 10px;
`;

const ButtonLink = styled.div`
  background-color: ${(props) =>
    props.$backgroundColor ? Theme.color["black-1"] : Theme.color["white"]};
  color: ${(props) =>
    props.$backgroundColor ? Theme.color["white"] : Theme.color["black-1"]};
  height: 35px; //40px
  border-radius: 30px;
  align-self: center;
  display: flex;
  cursor: pointer;
  text-align: -webkit-center;

  > p {
    align-self: center;
    padding: 0 24px;
  }
`;

export const BuildingHeader = ({
  item,
  buttons,
  changeHeaderSelectedTab,
  changeHeaderFloor,
  hideHeaderDropdwon,
}) => {
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const [floorsDropdownValue, setFloorsDropdownValue] = useState(null); //TODO Change to the deafult value of the API
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [actualDate] = useState(new Date());
  const [selectedTab, setSelectedTab] = useState(buttons?.[0]);

  //Fetch aos dados
  const {
    data: buidlingAndFloorsData,
    refetch: refetchBuidlingAndFloors,
    isLoading: buidlingAndFloorsIsLoading,
  } = useFetch(
    "/registry/buildings/floors",
    "buidlingAndFloors",
    {
      id: item?.id,
    },
    item.family.includes("Buildings") ? (item?.id ?? false) : false,
    null,
    query.middlewareURL
  );

  useEffect(() => {
    if (buidlingAndFloorsData) {
      const result = buidlingAndFloorsData.map((x) => {
        return { label: x.name, value: x.id, cpes: x.cpeList };
      });
      setFloorsDropdownValue(result[1]?.value);
      changeHeaderFloor(result[1]);
      if (Object.keys(buidlingAndFloorsData).length === 0) {
        logger.warn("User: " + user?.Username + " Tenant: " + tenant + ", buidlingAndFloorsData is a empty object!");
      }
    }
  }, [buidlingAndFloorsData]);

  useEffect(() => {
    setSelectedTab(buttons?.[0]);
    changeHeaderSelectedTab(buttons?.[0]);
  }, [buttons]);

  function changeTab(tab) {
    setSelectedTab(tab);
    changeHeaderSelectedTab(tab);
  }

  return (
    <PageContent>
      <PageSection $padding={`${Theme.spacing["s06"]} ${Theme.spacing["s04"]}`}>
        <Flex>
          <Row style={{ width: "100%" }}>
            <Col span={10} offset={6}>
              {buttons?.length > 1 ? (
                <SegmentedWarper>
                  <SegmentedControlStyle>
                    {buttons?.map((x, index) => {
                      return (
                        <ButtonLink
                          key={index}
                          onClick={() => changeTab(x)}
                          $backgroundColor={selectedTab == x ? true : false}
                        >
                          <p>{t(x)}</p>
                        </ButtonLink>
                      );
                    })}
                  </SegmentedControlStyle>
                </SegmentedWarper>
              ) : null}
            </Col>
            <Col
              span={8}
              style={{
                alignContent: "center",
                display: hideHeaderDropdwon ? "none" : null,
              }}
            >
              <Row>
                <Col span={5} offset={item.family.includes("Buildings") ? 9 : 19} style={{ alignContent: "center" }}>
                  <Text $marginRight="s06">
                    {actualDate.getDate() +
                      " " +
                      t(months[actualDate.getMonth()])}
                  </Text>
                </Col>
                {item.family.includes("Buildings") ?
                  <Col span={10}>
                    {!buidlingAndFloorsIsLoading ? (
                      <SelectAtomic
                        optionsData={
                          buidlingAndFloorsData
                            ? buidlingAndFloorsData.map((x) => {
                              return {
                                label: x.name,
                                value: x.id,
                                cpes: x.cpeList,
                              };
                            })
                            : []
                        }
                        handleOptionsChange={(value, record) => {
                          setFloorsDropdownValue(value);
                          changeHeaderFloor(record);
                        }}
                        defaultValue={floorsDropdownValue}
                        fullWidth={true}
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Spinner stroke="green" size="20px" />
                      </div>
                    )}
                  </Col>
                  : null}
              </Row>
            </Col>
          </Row>
        </Flex>
      </PageSection>
    </PageContent>
  );
};
